import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferGameAndBrandVo } from './type';

/**
 * 当前卖家所有offer所涵盖的游戏/品牌
  GET /product/offerManage/getEntityByOffer
  接口ID：263628566
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628566
 */
export const getOfferGameAndBrand = (): AxiosPromise<OfferGameAndBrandVo[]> => {
  return request({
    url: '/product/offerManage/getEntityByOffer',
    method: 'get'
  });
};
